import { yupResolver } from "@hookform/resolvers/yup";
import { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import ActionsBar from "../../components/ActionsBar/ActionsBar";
import ToolHeader from "../../components/ToolHeader/ToolHeader";
import useSavedResults from "../../helpers/useSavedResults";
import "./Vila.css";
import * as yup from "yup";
import { setFormErrors } from "../../helpers/util";
import HiddenToolFields from "../../components/HiddenToolFields";
import FormElement from "../../components/FormElement/FormElement";
import Wrapper from "../../components/Wrapper/Wrapper";
import ResultSection from "../../components/results/ResultSection";
import Label from "../../components/form-elements/Label";
import InputWrapper from "../../components/form-elements/InputWrapper";
import ResultWrapper from "../../components/results/ResultWrapper";
import InputSection from "../../components/form-elements/InputSection";
import Error from "../../components/form-elements/Error";
import { Input } from "../../components/form-elements/Input";
import FormInput from "../../components/FormInput/FormInput";
import FormSection from "../../components/FormSection/FormSection";
import InputColumn from "../../components/InputColumn/InputColumn";

const schema = yup
  .object({
    E15: yup.number().typeError("Endast numeriskt värde tillåtet"), // C3: Antal kalvningar vår
    E17: yup.number().typeError("Endast numeriskt värde tillåtet").nullable(), // C4: Ålder vi avvänjning
    E19: yup.number().typeError("Endast numeriskt värde tillåtet").nullable(), // C5: Ålder vid slakt tjurar
  })
  .required();

export default function ViLA() {
  const [serverMessages, setServerMessages] = useState([]);
  const [hasResults, setHasResults] = useState(
    window.wpObject.tool_data != null
  );
  const { displaySavedAlert } = useSavedResults();

  const visitIntervals = {
    0: {
      normal: "0",
      extended: "0",
    },
    1: {
      normal: "var 3:e",
      extended: "var 6:e",
    },
    2: {
      normal: "varannan",
      extended: "var 4:e",
    },
    3: {
      normal: "varje",
      extended: "varannan",
    },
  };

  const methods = useForm({
    defaultValues: {
      E15:
        window.wpObject?.tool_data?.data?.E15 != null
          ? window.wpObject?.tool_data?.data?.E15
          : 0, // E15: Självdöda/avlivade kor senaste 12 månaderna
      E17:
        window.wpObject?.tool_data?.data?.E17 != null
          ? window.wpObject?.tool_data?.data?.E17
          : 0, // E17: Dödlighet kvigkalvar 1-60 dagar senaste 12 månaderna
      E19:
        window.wpObject?.tool_data?.data?.E19 != null
          ? window.wpObject?.tool_data?.data?.E19
          : 0, // E19: Mastitbehandlingar senaste 12 månaderna

      // Vilken storlek är det på besättningen - marker med kryss
      C34:
        window.wpObject?.tool_data?.data?.C34 != null
          ? window.wpObject?.tool_data?.data?.C34
          : 0,

      E40:
        window.wpObject?.tool_data?.data?.E40 != null
          ? window.wpObject?.tool_data?.data?.E40
          : 0, // E40: Dödlighet spädkalv 0-1 dag
      E41:
        window.wpObject?.tool_data?.data?.E41 != null
          ? window.wpObject?.tool_data?.data?.E41
          : 0, // E41: Dödlighet kalv 1-180 dagar
      E42:
        window.wpObject?.tool_data?.data?.E42 != null
          ? window.wpObject?.tool_data?.data?.E42
          : 0, // E42: Självdöda/avlivade kor
      E43:
        window.wpObject?.tool_data?.data?.E43 != null
          ? window.wpObject?.tool_data?.data?.E43
          : 0, // E43: Utrofdringsrelaterad sjuklighet
      E44:
        window.wpObject?.tool_data?.data?.E44 != null
          ? window.wpObject?.tool_data?.data?.E44
          : 0, // E44: Totalt sjukdomsbehandlingar
      E45:
        window.wpObject?.tool_data?.data?.E45 != null
          ? window.wpObject?.tool_data?.data?.E45
          : 0, // E45: Andel kor med sena semineringar
      E46:
        window.wpObject?.tool_data?.data?.E46 != null
          ? window.wpObject?.tool_data?.data?.E46
          : 0, // E46: Andel ej seminerade kvigor över 17 månader
    },
    resolver: yupResolver(schema),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;
  const form = useRef(null);
  const [result, setResult] = useState({
    E5:
      window.wpObject?.tool_data?.data?.E5 != null
        ? window.wpObject?.tool_data?.data?.E5
        : "0", // E5: Uppfyller du villkoren för att få ha ViLA?
    E49:
      window.wpObject?.tool_data?.data?.E49 != null
        ? window.wpObject?.tool_data?.data?.E49
        : "0", // E49: Om ifyllda uppgifter stämmer bör ditt besöksintervall bli
  });

  const handleCalculate = (formData) => {
    setServerMessages([]);

    if (window?.wpObject?.ajax_url == null) {
      return;
    }

    const requestData = new FormData(form.current);
    requestData.append("action", "wt_ajax_tools_vila");

    fetch(window.wpObject.ajax_url, {
      method: "POST",
      body: requestData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          setResult(response.data);
          setHasResults(true);
        } else {
          if ("errorsItemized" in response.data) {
            setFormErrors(response.data.errorsItemized, methods);
          }
          if ("errors" in response.data) {
            setServerMessages(response.data.errors.map((e) => e));
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSaveResults = async () => {
    if (window?.wpObject?.ajax_url == null) {
      return;
    }
    const requestData = new FormData(form.current);
    requestData.append("action", "save_tool_vila");
    Object.keys(result)
      .filter((cell) => !requestData.has(cell))
      .map((rCell) => requestData.append(rCell, result[rCell]));

    fetch(window.wpObject.ajax_url, {
      method: "POST",
      body: requestData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          if (window?.wpObject?.saved_results_url != null) {
            displaySavedAlert();
          } else {
            setServerMessages([response.data.message]);
          }
        } else {
          if ("errorsItemized" in response.data) {
            setFormErrors(response.data.errorsItemized, methods);
          }
          if ("errors" in response.data) {
            setServerMessages(response.data.errors.map((e) => e));
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className={"tool-base"}>
      <ToolHeader />
      <ActionsBar
        hasResults={hasResults}
        onCalculate={handleSubmit(handleCalculate)}
        onSave={handleSubmit(handleSaveResults)}
        serverMessages={serverMessages}
      />

      <form ref={form} onSubmit={handleSubmit(handleCalculate)}>
        <HiddenToolFields />
        <FormSection className={"1"}>
          <Wrapper>
            <h4 className={"section-one-result"}>
              <span>A. Uppfyller du villkoren för att få ha ViLA?</span>
              <div className={"inputs"}>
                <FormInput value={result?.E5} />
              </div>
            </h4>
            <InputColumn>
              <div className={"left-column"}>
                <div className={"card"}>
                  <p>
                    Beräkningarna utgår från senaste 12 månaderna och redovisas
                    inför ny 12 månaders period
                  </p>
                  <p>
                    Uppgifter kan hämtas från "signaler djurvälfärd" på Växa
                    Sverige`s hemsida under "Mina sidor"
                  </p>
                  <p>
                    <div>
                      Kommer du inte åt dina uppgifterna på "Mina Sidor"…kan du
                      beställa dom från:
                    </div>
                    <div>Växa Sverige - Ann Nyman </div>
                    <div>Telefon: 010-471 06 56 eller 070-2502346, </div>
                    <div>Mail: ann.nyman@vxa.se</div>
                  </p>
                </div>
              </div>
              <div className={"right-column"}>
                <FormElement
                  label="Självdöda/avlivade kor senaste 12 månaderna"
                  id="E15"
                  unit="%"
                  register={register}
                  errors={errors?.E15}
                />
                <FormElement
                  label="Dödlighet kvigkalvar 1-60 dagar senaste 12 månaderna"
                  id="E17"
                  unit="%"
                  register={register}
                  errors={errors?.E17}
                />
                <FormElement
                  label="Mastitbehandlingar senaste 12 månaderna"
                  id="E19"
                  unit="%"
                  register={register}
                  errors={errors?.E19}
                />
              </div>
            </InputColumn>
          </Wrapper>
        </FormSection>
        <FormSection className={"2"}>
          <Wrapper>
            <h4>
              B. Besöksintervall - Hur ofta måste din besättningsveterinär
              besöka gården?
            </h4>
            <InputColumn>
              <div className={"left-column"}>
                <div className={"card"}>
                  <p>
                    Beräkningarna utgår från senaste 12 månaderna och redovisas
                    varje kvartal för att bestämma besöksintervall för kommande
                    kvartal
                  </p>
                  <p>
                    Uppgifter kan hämtas från "signaler djurvälfärd" på Växa
                    Sverige`s hemsida under "Mina sidor"
                  </p>
                  <p>
                    <div>
                      Kommer du inte åt dina uppgifterna på "Mina Sidor"…kan du
                      beställa dom från:
                    </div>
                    <div>Växa Sverige - Ann Nyman </div>
                    <div>Telefon: 010-471 06 56 eller 070-2502346, </div>
                    <div>Mail: ann.nyman@vxa.se</div>
                  </p>
                </div>
              </div>
              <div className={"right-column"}>
                <InputSection column>
                  <Label
                    className="column xlarge-6 medium-12"
                    htmlFor="C34"
                    label="Vilken storlek är det på besättningen"
                  >
                    <Error message={errors?.F42?.message} />
                  </Label>
                  <div className="column xlarge-6 medium-12 xlarge-text-right">
                    <span className={"radio-input-wrapper"}>
                      <Input
                        type="radio"
                        {...register("C34")}
                        value="1"
                        id="size-1"
                      />{" "}
                      {/* <100 */}
                      <label htmlFor="size-1">{"<"}100</label>
                    </span>
                    <span className={"radio-input-wrapper"}>
                      <Input
                        type="radio"
                        {...register("C34")}
                        value="2"
                        id="size-2"
                      />{" "}
                      {/* 100-250 */}
                      <label htmlFor="size-2">100-250</label>
                    </span>
                    <span className={"radio-input-wrapper"}>
                      <Input
                        type="radio"
                        {...register("C34")}
                        value="3"
                        id="size-3"
                      />{" "}
                      {/* >250 */}
                      <label htmlFor="size-3">{">"}250</label>
                    </span>
                  </div>
                </InputSection>

                <FormElement
                  label="Dödlighet spädkalv 0-1 dag"
                  id="E40"
                  unit="%"
                  register={register}
                  errors={errors?.E40}
                />
                <FormElement
                  label="Dödlighet kalv 1-180 dagar"
                  id="E41"
                  unit="%"
                  register={register}
                  errors={errors?.E41}
                />
                <FormElement
                  label="Självdöda/avlivade kor"
                  id="E42"
                  unit="%"
                  register={register}
                  errors={errors?.E42}
                />
                <FormElement
                  label="Utrofdringsrelaterad sjuklighet"
                  id="E43"
                  unit="%"
                  register={register}
                  errors={errors?.E43}
                />
                <FormElement
                  label="Totalt sjukdomsbehandlingar"
                  id="E44"
                  unit="%"
                  register={register}
                  errors={errors?.E44}
                />
                <FormElement
                  label="Andel kor med sena semineringar"
                  id="E45"
                  unit="%"
                  register={register}
                  errors={errors?.E45}
                />
                <FormElement
                  label="Andel ej seminerade kvigor över 17 månader"
                  id="E46"
                  unit="%"
                  register={register}
                  errors={errors?.E46}
                />
              </div>
            </InputColumn>
          </Wrapper>
        </FormSection>
        <FormSection className={"3"}>
          <Wrapper>
            <header className="column">
              <h4>
                Resultat - Om ifyllda uppgifter stämmer bör ditt besöksintervall
                bli
              </h4>
            </header>
            <div className="">
              <ResultSection final>
                <Label
                  className="column large-8 medium-6 small-6 xsmall-12"
                  label="Normalt intervall för besök av din besättningsveterinär"
                />
                <InputWrapper
                  className="column large-4 medium-6 small-6 xsmall-12"
                  title="vecka"
                >
                  <ResultWrapper>
                    {result?.E49 !== "" ? visitIntervals[result.E49].normal : 0}
                  </ResultWrapper>
                </InputWrapper>
              </ResultSection>

              <ResultSection final>
                <Label
                  className="column large-8 medium-6 small-6 xsmall-12"
                  label="Utökat intervall för besök av din besättningsveterinär"
                />
                <InputWrapper
                  className="column large-4 medium-6 small-6 xsmall-12"
                  title="vecka"
                >
                  <ResultWrapper>
                    {result?.E49 !== ""
                      ? visitIntervals[result.E49].extended
                      : 0}
                  </ResultWrapper>
                </InputWrapper>
              </ResultSection>
            </div>
          </Wrapper>
        </FormSection>
      </form>

      <ActionsBar
        hasResults={hasResults}
        onCalculate={handleSubmit(handleCalculate)}
        onSave={handleSubmit(handleSaveResults)}
        serverMessages={serverMessages}
      />
    </div>
  );
}
